module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANAQMAAABIJXY/AAAABlBMVEX///+3t7drUiW7AAAAAXRSTlMAQObYZgAAAB5JREFUCB1jYEAFTAxMrAyM/IVMAg5MCgpMDgIQaQASfAFxByntqQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/arrow-desc.png
// module id = 192
// module chunks = 0